export default __webpack_public_path__ + "static/media/credit-card.f10cd290.svg";